/**
 * PANGEA ATLAS – INTERACTIVE CORE ENGINE (2-MINUTEN ANGEL-VIDEO-HUB)
 * 100% Xtra-Theme konfliktfrei (nutzt div[role="button"] & Body-Portal für Modals)
 */

(function () {
  "use strict";

  const STORAGE_WATCHED_KEY = "pangea_atlas_watched_v1";
  const STORAGE_BOOKMARKS_KEY = "pangea_atlas_bookmarks_v1";

  const state = {
    category: "alle",
    level: "alle",
    format: "alle",
    quickFilter: "alle", // "alle" | "bookmarks" | "unwatched"
    playlistId: null,
    searchQuery: "",
    activeVideoId: null,
    watched: [],
    bookmarks: [],
    simTimer: null,
    simPlaying: false,
    simSeconds: 0,
    simSpeed: 1
  };

  /* --------------------------------------------------------------------------
     1. LOCALSTORAGE PERSISTENZ
     -------------------------------------------------------------------------- */
  function loadUserState() {
    try {
      const w = JSON.parse(localStorage.getItem(STORAGE_WATCHED_KEY) || "[]");
      const b = JSON.parse(localStorage.getItem(STORAGE_BOOKMARKS_KEY) || "[]");
      if (Array.isArray(w)) state.watched = w;
      if (Array.isArray(b)) state.bookmarks = b;
    } catch (e) {
      state.watched = [];
      state.bookmarks = [];
    }
  }

  function saveWatched() {
    try {
      localStorage.setItem(STORAGE_WATCHED_KEY, JSON.stringify(state.watched));
    } catch (e) {}
  }

  function saveBookmarks() {
    try {
      localStorage.setItem(STORAGE_BOOKMARKS_KEY, JSON.stringify(state.bookmarks));
    } catch (e) {}
  }

  function isWatched(id) {
    return state.watched.indexOf(id) !== -1;
  }

  function isBookmarked(id) {
    return state.bookmarks.indexOf(id) !== -1;
  }

  function toggleWatched(id) {
    const idx = state.watched.indexOf(id);
    if (idx === -1) {
      state.watched.push(id);
      showToast("✅ Als gemeistert markiert! Petri Heil!");
    } else {
      state.watched.splice(idx, 1);
      showToast("↩️ Aus 'Gesehen' entfernt");
    }
    saveWatched();
    updateProgressHeader();
    renderCatalogGrid();
    if (state.activeVideoId === id) {
      updateModalActionButtons(id);
    }
  }

  function toggleBookmark(id, evt) {
    if (evt && evt.stopPropagation) evt.stopPropagation();
    const idx = state.bookmarks.indexOf(id);
    if (idx === -1) {
      state.bookmarks.push(id);
      showToast("⭐ Auf deiner persönlichen Merkliste gespeichert");
    } else {
      state.bookmarks.splice(idx, 1);
      showToast("Merklisten-Eintrag entfernt");
    }
    saveBookmarks();
    updateProgressHeader();
    renderCatalogGrid();
    if (state.activeVideoId === id) {
      updateModalActionButtons(id);
    }
  }

  /* --------------------------------------------------------------------------
     2. BODY-PORTAL MOUNTING (SCHÜTZT VOR XTRA-THEME #ROOT STACKING & OVERFLOW)
     -------------------------------------------------------------------------- */
  function ensureBodyPortals() {
    const modal = document.getElementById("pangeaAtlasModal");
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    let toast = document.getElementById("pangeaAtlasToast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "pangeaAtlasToast";
      toast.className = "pangea-atlas-toast";
      document.body.appendChild(toast);
    } else if (toast.parentElement !== document.body) {
      document.body.appendChild(toast);
    }
  }

  let toastTimeout = null;
  function showToast(msg) {
    const toast = document.getElementById("pangeaAtlasToast");
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("pa-toast-show");
    if (toastTimeout) clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function () {
      toast.classList.remove("pa-toast-show");
    }, 2800);
  }

  /* --------------------------------------------------------------------------
     3. FORTSCHRITTS-BALKEN & MERKLISTEN-ZÄHLER
     -------------------------------------------------------------------------- */
  function updateProgressHeader() {
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const total = videos.length || 1;
    const watchedCount = videos.filter(function (v) {
      return isWatched(v.id);
    }).length;
    const pct = Math.min(100, Math.round((watchedCount / total) * 100));

    const countEl = document.getElementById("paProgressCount");
    const fillEl = document.getElementById("paProgressFill");
    const bmCountEl = document.getElementById("paBookmarkCount");

    if (countEl) {
      countEl.textContent = watchedCount + " / " + videos.length + " gemeistert (" + pct + " %)";
    }
    if (fillEl) {
      fillEl.style.width = pct + "%";
    }
    if (bmCountEl) {
      bmCountEl.textContent = "(" + state.bookmarks.length + ")";
    }

    const chipBookmarks = document.getElementById("paQuickBookmarks");
    const chipUnwatched = document.getElementById("paQuickUnwatched");
    if (chipBookmarks) {
      chipBookmarks.classList.toggle("pa-is-active", state.quickFilter === "bookmarks");
    }
    if (chipUnwatched) {
      chipUnwatched.classList.toggle("pa-is-active", state.quickFilter === "unwatched");
    }
  }

  /* --------------------------------------------------------------------------
     4. HERO STAGE & PLAYLISTS RENDERN
     -------------------------------------------------------------------------- */
  function renderHeroStage() {
    const container = document.getElementById("paHeroStage");
    if (!container) return;
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const featured = videos.find(function (v) { return v.featured; }) || videos[0];
    if (!featured) {
      container.style.setProperty("display", "none", "important");
      return;
    }
    container.style.removeProperty("display");

    const takeawaysHtml = (featured.takeaways || []).map(function (t) {
      return (
        '<div class="pa-hero-takeaway-item">' +
          '<span class="pa-hero-takeaway-check">✔</span>' +
          '<span>' + escapeHtml(t) + '</span>' +
        '</div>'
      );
    }).join("");

    const chaptersHtml = (featured.chapters || []).map(function (ch) {
      return '<div class="pa-hero-chapter-pill">' + escapeHtml(ch.time + " • " + ch.label) + '</div>';
    }).join("");

    const primaryShop = (featured.shopLinks && featured.shopLinks[0]) ? featured.shopLinks[0] : { title: "Passendes Tackle im Shop", handle: "shop" };

    container.innerHTML =
      '<div class="pa-hero-content">' +
        '<div class="pa-hero-badges">' +
          '<span class="pa-badge-featured">★ 2-Minuten-Masterclass der Woche</span>' +
          '<span class="pa-badge-duration">⏱ ' + escapeHtml(featured.duration) + ' MIN</span>' +
          '<span class="pa-badge-level">' + escapeHtml(featured.category) + ' • ' + escapeHtml(featured.level) + '</span>' +
        '</div>' +
        '<h2 class="pa-hero-title">' + escapeHtml(featured.title) + '</h2>' +
        '<p class="pa-hero-desc">' + escapeHtml(featured.summary) + '</p>' +
        '<div class="pa-hero-takeaways">' + takeawaysHtml + '</div>' +
        '<div class="pa-hero-actions">' +
          '<div role="button" tabindex="0" class="pa-btn-primary" onclick="window.PangeaAtlas.openVideo(\'' + featured.id + '\')">' +
            '<span>▶ Jetzt 2-Minuten-Video starten</span>' +
          '</div>' +
          '<a class="pa-btn-secondary" href="/collections/' + encodeURIComponent(primaryShop.handle) + '">' +
            '<span>🛒 ' + escapeHtml(primaryShop.title) + '</span>' +
          '</a>' +
        '</div>' +
      '</div>' +
      '<div class="pa-hero-visual" onclick="window.PangeaAtlas.openVideo(\'' + featured.id + '\')" role="button" tabindex="0" aria-label="Video starten">' +
        '<img class="pa-hero-visual-bg" src="' + escapeAttr(featured.thumbnail) + '" alt="' + escapeAttr(featured.title) + '" loading="eager">' +
        '<div class="pa-hero-visual-overlay"></div>' +
        '<div class="pa-hero-visual-top">' +
          '<span class="pa-card-cat-pill">🎯 Sofort-Praxiswissen</span>' +
          '<span class="pa-card-duration">HD • ' + escapeHtml(featured.duration) + '</span>' +
        '</div>' +
        '<div class="pa-hero-play-orb">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>' +
        '</div>' +
        '<div class="pa-hero-visual-bottom">' +
          '<div class="pa-hero-chapters-strip">' + chaptersHtml + '</div>' +
        '</div>' +
      '</div>';
  }

  function renderPlaylists() {
    const grid = document.getElementById("paPlaylistsGrid");
    if (!grid) return;
    const playlists = window.PANGEA_ATLAS_PLAYLISTS || [];

    grid.innerHTML = playlists.map(function (pl) {
      const isActive = state.playlistId === pl.id;
      return (
        '<div role="button" tabindex="0" class="pa-playlist-card' + (isActive ? ' pa-is-active' : '') + '" onclick="window.PangeaAtlas.selectPlaylist(\'' + pl.id + '\')">' +
          '<div class="pa-playlist-top">' +
            '<span class="pa-playlist-tag">' + escapeHtml(pl.tag) + '</span>' +
            '<span class="pa-playlist-meta">' + escapeHtml(pl.meta) + '</span>' +
          '</div>' +
          '<div class="pa-playlist-title">' + escapeHtml(pl.title) + '</div>' +
          '<div class="pa-playlist-desc">' + escapeHtml(pl.desc) + '</div>' +
        '</div>'
      );
    }).join("");
  }

  /* --------------------------------------------------------------------------
     5. KATEGORIE-TABS & FILTER-LOGIK
     -------------------------------------------------------------------------- */
  function renderCategoryTabs() {
    const tabRow = document.getElementById("paCategoryTabs");
    if (!tabRow) return;
    const cats = window.PANGEA_ATLAS_CATEGORIES || [];
    const videos = window.PANGEA_ATLAS_VIDEOS || [];

    tabRow.innerHTML = cats.map(function (c) {
      const count = c.id === "alle"
        ? videos.length
        : videos.filter(function (v) { return v.category === c.id; }).length;
      const isActive = state.category === c.id && !state.playlistId;

      return (
        '<div role="button" tabindex="0" class="pa-cat-tab' + (isActive ? ' pa-is-active' : '') + '" onclick="window.PangeaAtlas.setCategory(\'' + escapeAttr(c.id) + '\')">' +
          '<span>' + escapeHtml(c.icon + " " + c.label) + '</span>' +
          '<span class="pa-cat-count">' + count + '</span>' +
        '</div>'
      );
    }).join("");
  }

  function getFilteredVideos() {
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const playlists = window.PANGEA_ATLAS_PLAYLISTS || [];
    let activePlaylist = null;
    if (state.playlistId) {
      activePlaylist = playlists.find(function (p) { return p.id === state.playlistId; }) || null;
    }

    const q = (state.searchQuery || "").trim().toLowerCase();

    return videos.filter(function (v) {
      if (activePlaylist && activePlaylist.videoIds.indexOf(v.id) === -1) {
        return false;
      }
      if (!activePlaylist && state.category !== "alle" && v.category !== state.category) {
        return false;
      }
      if (state.level !== "alle" && v.level !== state.level) {
        return false;
      }
      if (state.format !== "alle" && v.format !== state.format) {
        return false;
      }
      if (state.quickFilter === "bookmarks" && !isBookmarked(v.id)) {
        return false;
      }
      if (state.quickFilter === "unwatched" && isWatched(v.id)) {
        return false;
      }
      if (q) {
        const hay = (
          v.title + " " +
          v.category + " " +
          v.level + " " +
          v.summary + " " +
          (v.takeaways || []).join(" ")
        ).toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    });
  }

  function renderCatalogGrid() {
    const grid = document.getElementById("paVideoGrid");
    const countEl = document.getElementById("paResultsCount");
    const resetEl = document.getElementById("paResetFilters");
    const clearSearchEl = document.getElementById("paSearchClear");
    if (!grid) return;

    const filtered = getFilteredVideos();
    const total = (window.PANGEA_ATLAS_VIDEOS || []).length;

    const hasActiveFilter =
      state.category !== "alle" ||
      state.level !== "alle" ||
      state.format !== "alle" ||
      state.quickFilter !== "alle" ||
      state.playlistId !== null ||
      state.searchQuery.trim() !== "";

    if (countEl) {
      if (state.playlistId) {
        const pl = (window.PANGEA_ATLAS_PLAYLISTS || []).find(function (p) { return p.id === state.playlistId; });
        countEl.textContent = "Playlist aktiv: „" + (pl ? pl.title : "") + "“ (" + filtered.length + " Videos)";
      } else {
        countEl.textContent = filtered.length + " von " + total + " Erklärvideos (je 02:00 Min.)";
      }
    }

    if (resetEl) {
      resetEl.classList.toggle("pa-visible", hasActiveFilter);
    }
    if (clearSearchEl) {
      clearSearchEl.classList.toggle("pa-visible", state.searchQuery.trim().length > 0);
    }

    if (filtered.length === 0) {
      if (total === 0) {
        grid.innerHTML =
          '<div style="grid-column: 1 / -1; background: rgba(4, 30, 58, 0.72); border: 1px dashed rgba(0, 206, 209, 0.4); border-radius: 16px; padding: 42px 24px; text-align: center;">' +
            '<div style="font-size: 18px; font-weight: 700; color: #FFFFFF; margin-bottom: 8px;">Pangea Atlas ist bereit für deine 2-Minuten-Videos</div>' +
            '<p style="font-size: 14px; color: #cbd5e1; margin-bottom: 0 !important;">Alle Kategorien, Filter, Lernpfade und der Kino-Player sind aktiv. Sobald neue Videos hinterlegt werden, erscheinen sie automatisch hier.</p>' +
          '</div>';
        return;
      }
      grid.innerHTML =
        '<div style="grid-column: 1 / -1; background: rgba(4, 30, 58, 0.72); border: 1px dashed rgba(0, 206, 209, 0.4); border-radius: 16px; padding: 36px 20px; text-align: center;">' +
          '<div style="font-size: 18px; font-weight: 700; color: #FFFFFF; margin-bottom: 8px;">Keine 2-Minuten-Videos für diesen Filter gefunden</div>' +
          '<p style="font-size: 14px; color: #cbd5e1; margin-bottom: 16px !important;">Setze die Filter zurück, um wieder alle ' + total + ' Angel-Guides zu sehen.</p>' +
          '<div role="button" tabindex="0" class="pa-btn-primary" onclick="window.PangeaAtlas.resetFilters()">Alle Videos anzeigen</div>' +
        '</div>';
      return;
    }

    grid.innerHTML = filtered.map(function (v) {
      const watched = isWatched(v.id);
      const bookmarked = isBookmarked(v.id);
      const shopItem = (v.shopLinks && v.shopLinks[0]) ? v.shopLinks[0] : { title: "Passendes Tackle", handle: "shop" };

      return (
        '<div class="pa-video-card' + (watched ? ' pa-is-watched' : '') + '">' +
          '<div class="pa-card-thumb" onclick="window.PangeaAtlas.openVideo(\'' + v.id + '\')">' +
            '<img class="pa-card-thumb-img" src="' + escapeAttr(v.thumbnail) + '" alt="' + escapeAttr(v.title) + '" loading="lazy">' +
            '<div class="pa-card-thumb-gradient"></div>' +
            '<div class="pa-card-top-badges">' +
              '<span class="pa-card-cat-pill">' + escapeHtml(v.category) + '</span>' +
              '<div role="button" tabindex="0" class="pa-card-bookmark-btn' + (bookmarked ? ' pa-is-bookmarked' : '') + '" onclick="window.PangeaAtlas.toggleBookmark(\'' + v.id + '\', event)" title="Auf Merkliste speichern">' +
                (bookmarked ? '★' : '☆') +
              '</div>' +
            '</div>' +
            '<div class="pa-card-play-btn">' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>' +
            '</div>' +
            '<div class="pa-card-bottom-meta">' +
              '<span class="pa-card-duration">⏱ ' + escapeHtml(v.duration) + '</span>' +
              (watched ? '<span class="pa-card-watched-badge">✔ Gemeistert</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="pa-card-body">' +
            '<div class="pa-card-level-row">' +
              '<span class="pa-card-level">🎯 ' + escapeHtml(v.level) + '</span>' +
              '<span class="pa-card-format">Format ' + escapeHtml(v.format) + '</span>' +
            '</div>' +
            '<h3 class="pa-card-title" onclick="window.PangeaAtlas.openVideo(\'' + v.id + '\')">' + escapeHtml(v.title) + '</h3>' +
            '<p class="pa-card-summary">' + escapeHtml(v.summary) + '</p>' +
          '</div>' +
          '<div class="pa-card-footer">' +
            '<div role="button" tabindex="0" class="pa-card-watch-cta" onclick="window.PangeaAtlas.openVideo(\'' + v.id + '\')">' +
              '<span>▶ Video & Spickzettel</span>' +
            '</div>' +
            '<a class="pa-card-shop-link" href="/collections/' + encodeURIComponent(shopItem.handle) + '" title="' + escapeAttr(shopItem.title) + '">' +
              '<span>🛒 Tackle</span>' +
            '</a>' +
          '</div>' +
        '</div>'
      );
    }).join("");
  }

  /* --------------------------------------------------------------------------
     6. KINO-THEATER-MODAL & UNIVERSELLER HYBRID-PLAYER
     -------------------------------------------------------------------------- */
  function openVideo(videoId) {
    ensureBodyPortals();
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const video = videos.find(function (v) { return v.id === videoId; });
    if (!video) return;

    state.activeVideoId = video.id;
    stopSimulator();

    const modal = document.getElementById("pangeaAtlasModal");
    if (!modal) return;

    // Top Meta
    const catEl = document.getElementById("paModalCatBadge");
    const durEl = document.getElementById("paModalDurBadge");
    const lvlEl = document.getElementById("paModalLvlBadge");
    const titleEl = document.getElementById("paModalTitle");
    const summaryEl = document.getElementById("paModalSummary");

    if (catEl) catEl.textContent = video.category;
    if (durEl) durEl.textContent = "⏱ " + video.duration + " MIN";
    if (lvlEl) lvlEl.textContent = video.level + " • " + video.format;
    if (titleEl) titleEl.textContent = video.title;
    if (summaryEl) summaryEl.textContent = video.summary;

    // Render Player Stage (MP4 / YouTube / Vimeo / Interactive 2-Min Simulator)
    renderPlayerStage(video);

    // Render Chapters
    renderModalChapters(video, 0);

    // Render 3-Step Spickzettel & Pro-Tip
    const stepsEl = document.getElementById("paModalTakeaways");
    if (stepsEl) {
      stepsEl.innerHTML = (video.takeaways || []).map(function (step, idx) {
        return (
          '<div class="pa-takeaway-step">' +
            '<span class="pa-step-num">' + (idx + 1) + '</span>' +
            '<span>' + escapeHtml(step) + '</span>' +
          '</div>'
        );
      }).join("");
    }

    const proTipEl = document.getElementById("paModalProTip");
    if (proTipEl) {
      proTipEl.innerHTML = "💡 <strong>Pangea Pro-Tipp:</strong> " + escapeHtml(video.proTip || "");
    }

    // Render Shop Links
    const shopContainer = document.getElementById("paModalShopLinks");
    if (shopContainer) {
      shopContainer.innerHTML = (video.shopLinks || []).map(function (sl) {
        return (
          '<a class="pa-shop-item-link" href="/collections/' + encodeURIComponent(sl.handle) + '">' +
            '<span>🎣 ' + escapeHtml(sl.title) + '</span>' +
            '<span class="pa-shop-cta-pill">Zum Shop →</span>' +
          '</a>'
        );
      }).join("");
    }

    // Render Compass Link & Next Video
    const compassLinkEl = document.getElementById("paModalCompassLink");
    if (compassLinkEl) {
      compassLinkEl.href = video.compassUrl || "/blogs/news";
      compassLinkEl.textContent = "📖 " + (video.compassTitle || "Vertiefender Artikel im Pangea Compass") + " →";
    }

    const currentIdx = videos.findIndex(function (v) { return v.id === video.id; });
    const nextVideo = videos[(currentIdx + 1) % videos.length];
    const nextBtn = document.getElementById("paModalNextBtn");
    if (nextBtn && nextVideo) {
      nextBtn.onclick = function () {
        openVideo(nextVideo.id);
      };
      nextBtn.textContent = "⏭ Nächstes 2-Min-Video: " + nextVideo.title;
    }

    updateModalActionButtons(video.id);

    modal.classList.add("pa-modal-open");
    document.body.style.overflow = "hidden";

    // URL Deep-Link aktualisieren (ohne Reload)
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("video", video.id);
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  function renderPlayerStage(video) {
    const stage = document.getElementById("paModalPlayerStage");
    if (!stage) return;

    if (video.videoUrl && video.videoUrl.trim() !== "") {
      stage.innerHTML =
        '<video id="paNativeVideo" class="pa-native-video" controls playsinline preload="auto" poster="' + escapeAttr(video.thumbnail) + '" src="' + escapeAttr(video.videoUrl) + '" style="display:block !important;visibility:visible !important;opacity:1 !important;width:100% !important;height:100% !important;object-fit:contain !important;background:#000811 !important;">' +
          '<source src="' + escapeAttr(video.videoUrl) + '" type="video/mp4">' +
          'Dein Browser unterstützt kein HTML5-Video.' +
        '</video>';
      const vidEl = document.getElementById("paNativeVideo");
      if (vidEl) {
        vidEl.addEventListener("timeupdate", function () {
          const cur = vidEl.currentTime || 0;
          const chapters = video.chapters || [];
          let activeIdx = 0;
          for (let i = 0; i < chapters.length; i++) {
            if (cur >= (chapters[i].sec || 0)) {
              activeIdx = i;
            }
          }
          renderModalChapters(video, activeIdx);
        });
        vidEl.addEventListener("ended", function () {
          if (!isWatched(video.id)) toggleWatched(video.id);
        });
        setTimeout(function () {
          try {
            const p = vidEl.play();
            if (p && typeof p.catch === "function") {
              p.catch(function () {});
            }
          } catch (e) {}
        }, 60);
      }
      return;
    }

    if (video.youtubeId && video.youtubeId.trim() !== "") {
      stage.innerHTML =
        '<iframe id="paYoutubeIframe" src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(video.youtubeId) + '?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      return;
    }

    if (video.vimeoId && video.vimeoId.trim() !== "") {
      stage.innerHTML =
        '<iframe id="paVimeoIframe" src="https://player.vimeo.com/video/' + encodeURIComponent(video.vimeoId) + '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      return;
    }

    // Interaktiver 2-Minuten Pangea Taktik-Vorschau-Simulator
    state.simSeconds = 0;
    state.simPlaying = true;
    const firstChapter = (video.chapters && video.chapters[0]) ? video.chapters[0] : { time: "00:00", label: video.title, detail: video.summary };

    stage.innerHTML =
      '<div class="pa-sim-stage">' +
        '<img class="pa-hero-visual-bg" src="' + escapeAttr(video.thumbnail) + '" alt="' + escapeAttr(video.title) + '" style="opacity: 0.25 !important;">' +
        '<div class="pa-hero-visual-overlay"></div>' +
        '<div class="pa-sim-hud-top">' +
          '<span class="pa-sim-live-pill">📡 PANGEA 2-MIN TAKTIK-PLAYER • ' + escapeHtml(video.category) + '</span>' +
          '<span class="pa-card-duration" id="paSimBadgeRight">Kapitel 1 / ' + (video.chapters ? video.chapters.length : 4) + '</span>' +
        '</div>' +
        '<div class="pa-sim-center">' +
          '<span class="pa-sim-step-badge" id="paSimStepTime">Kapitel ab ' + escapeHtml(firstChapter.time) + '</span>' +
          '<div class="pa-sim-chapter-heading" id="paSimChapterTitle">' + escapeHtml(firstChapter.label) + '</div>' +
          '<div class="pa-sim-chapter-text" id="paSimChapterDetail">' + escapeHtml(firstChapter.detail) + '</div>' +
        '</div>' +
        '<div class="pa-sim-controls">' +
          '<div class="pa-sim-timeline" id="paSimTimeline" onclick="window.PangeaAtlas.scrubSimulator(event)">' +
            '<div class="pa-sim-timeline-fill" id="paSimTimelineFill" style="width: 0%;"></div>' +
          '</div>' +
          '<div class="pa-sim-ctrl-row">' +
            '<div role="button" tabindex="0" class="pa-sim-play-toggle" id="paSimPlayBtn" onclick="window.PangeaAtlas.toggleSimulatorPlay()">⏸ Pause</div>' +
            '<span class="pa-sim-time-readout" id="paSimTimeReadout">00:00 / 02:00</span>' +
            '<div role="button" tabindex="0" class="pa-sim-speed-btn" id="paSimSpeedBtn" onclick="window.PangeaAtlas.cycleSimulatorSpeed()">Tempo: ' + state.simSpeed + 'x</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    startSimulatorTimer(video);
  }

  function startSimulatorTimer(video) {
    stopSimulator();
    state.simTimer = setInterval(function () {
      if (!state.simPlaying) return;
      state.simSeconds = Math.min(120, state.simSeconds + state.simSpeed);
      updateSimulatorUI(video);
      if (state.simSeconds >= 120) {
        state.simPlaying = false;
        const playBtn = document.getElementById("paSimPlayBtn");
        if (playBtn) playBtn.textContent = "↻ Erneut abspielen";
        if (!isWatched(video.id)) {
          toggleWatched(video.id);
        }
      }
    }, 1000);
  }

  function stopSimulator() {
    if (state.simTimer) {
      clearInterval(state.simTimer);
      state.simTimer = null;
    }
    state.simPlaying = false;
  }

  function updateSimulatorUI(video) {
    const sec = Math.floor(state.simSeconds);
    const pct = Math.min(100, (sec / 120) * 100);
    const fill = document.getElementById("paSimTimelineFill");
    const readout = document.getElementById("paSimTimeReadout");
    if (fill) fill.style.width = pct + "%";
    if (readout) readout.textContent = formatTime(sec) + " / 02:00";

    const chapters = video.chapters || [];
    let activeIdx = 0;
    for (let i = 0; i < chapters.length; i++) {
      if (sec >= (chapters[i].sec || 0)) {
        activeIdx = i;
      }
    }
    const ch = chapters[activeIdx];
    if (ch) {
      const stepTime = document.getElementById("paSimStepTime");
      const chTitle = document.getElementById("paSimChapterTitle");
      const chDetail = document.getElementById("paSimChapterDetail");
      const badgeRight = document.getElementById("paSimBadgeRight");
      if (stepTime) stepTime.textContent = "Kapitel ab " + ch.time;
      if (chTitle) chTitle.textContent = ch.label;
      if (chDetail) chDetail.textContent = ch.detail;
      if (badgeRight) badgeRight.textContent = "Kapitel " + (activeIdx + 1) + " / " + chapters.length;
    }

    renderModalChapters(video, activeIdx);
  }

  function renderModalChapters(video, activeIdx) {
    const listEl = document.getElementById("paModalChaptersList");
    if (!listEl) return;
    const chapters = video.chapters || [];
    listEl.innerHTML = chapters.map(function (ch, idx) {
      const isCurrent = idx === activeIdx;
      return (
        '<div role="button" tabindex="0" class="pa-chapter-btn' + (isCurrent ? ' pa-is-active' : '') + '" onclick="window.PangeaAtlas.jumpToChapter(' + (ch.sec || 0) + ')">' +
          '<span class="pa-chapter-time">' + escapeHtml(ch.time) + '</span>' +
          '<span>' + escapeHtml(ch.label) + '</span>' +
        '</div>'
      );
    }).join("");
  }

  function jumpToChapter(sec) {
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const video = videos.find(function (v) { return v.id === state.activeVideoId; });
    if (!video) return;

    const nativeVid = document.getElementById("paNativeVideo");
    if (nativeVid) {
      nativeVid.currentTime = sec;
      nativeVid.play();
      return;
    }

    if (video.youtubeId && video.youtubeId.trim() !== "") {
      const yt = document.getElementById("paYoutubeIframe");
      if (yt) {
        yt.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(video.youtubeId) + "?autoplay=1&rel=0&start=" + sec;
      }
      return;
    }

    state.simSeconds = sec;
    state.simPlaying = true;
    const playBtn = document.getElementById("paSimPlayBtn");
    if (playBtn) playBtn.textContent = "⏸ Pause";
    updateSimulatorUI(video);
  }

  function updateModalActionButtons(videoId) {
    const watchedBtn = document.getElementById("paModalWatchedBtn");
    const bookmarkBtn = document.getElementById("paModalBookmarkBtn");
    const shareBtn = document.getElementById("paModalShareBtn");

    if (watchedBtn) {
      const done = isWatched(videoId);
      watchedBtn.classList.toggle("pa-is-done", done);
      watchedBtn.textContent = done ? "✔ Gemeistert (Erledigt)" : "○ Als gemeistert markieren";
      watchedBtn.onclick = function () { toggleWatched(videoId); };
    }
    if (bookmarkBtn) {
      const saved = isBookmarked(videoId);
      bookmarkBtn.classList.toggle("pa-is-saved", saved);
      bookmarkBtn.textContent = saved ? "★ Auf deiner Merkliste" : "☆ Auf Merkliste speichern";
      bookmarkBtn.onclick = function () { toggleBookmark(videoId); };
    }
    if (shareBtn) {
      shareBtn.onclick = function () {
        copyDeepLink(videoId);
      };
    }
  }

  function closeModal() {
    stopSimulator();
    const modal = document.getElementById("pangeaAtlasModal");
    const stage = document.getElementById("paModalPlayerStage");
    if (stage) stage.innerHTML = "";
    if (modal) modal.classList.remove("pa-modal-open");
    document.body.style.overflow = "";
    state.activeVideoId = null;

    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("video");
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  function copyDeepLink(videoId) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("video", videoId);
      const shareUrl = url.toString();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl).then(function () {
          showToast("🔗 Direkt-Link zum Video in die Zwischenablage kopiert!");
        });
      } else {
        showToast("🔗 Link: " + shareUrl);
      }
    } catch (e) {
      showToast("🔗 Direkt-Link bereit zum Teilen");
    }
  }

  /* --------------------------------------------------------------------------
     7. GOOGLE VIDEO-SEO (SCHEMA.ORG ITEMLIST & VIDEOOBJECT JSON-LD)
     -------------------------------------------------------------------------- */
  function injectVideoSchemaJsonLd() {
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    if (!videos.length) return;
    let existing = document.getElementById("pangeaAtlasSchemaJsonLd");
    if (!existing) {
      existing = document.createElement("script");
      existing.type = "application/ld+json";
      existing.id = "pangeaAtlasSchemaJsonLd";
      document.head.appendChild(existing);
    }

    const baseUrl = window.location.origin + window.location.pathname;
    const itemListElements = videos.map(function (v, idx) {
      return {
        "@type": "ListItem",
        "position": idx + 1,
        "item": {
          "@type": "VideoObject",
          "name": v.title,
          "description": v.summary,
          "thumbnailUrl": [v.thumbnail],
          "duration": "PT2M",
          "uploadDate": "2026-10-01T08:00:00+01:00",
          "contentUrl": v.videoUrl || (baseUrl + "?video=" + encodeURIComponent(v.id)),
          "embedUrl": baseUrl + "?video=" + encodeURIComponent(v.id)
        }
      };
    });

    const schemaData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Pangea Atlas – 2-Minuten Angel-Erklärvideos",
      "description": "Kompakte 2-Minuten-Erklärvideos rund ums Angeln, Knoten, Montagen, Zander, Hecht, Barsch, Karpfen, Wels und Echolot-Technik.",
      "numberOfItems": videos.length,
      "itemListElement": itemListElements
    };

    existing.textContent = JSON.stringify(schemaData);
  }

  /* --------------------------------------------------------------------------
     8. URL DEEP-LINKING (?video=..., ?cat=..., ?level=..., ?playlist=...)
     -------------------------------------------------------------------------- */
  function applyUrlParams() {
    try {
      const params = new URLSearchParams(window.location.search);
      const catParam = params.get("cat");
      const levelParam = params.get("level");
      const playlistParam = params.get("playlist");
      const videoParam = params.get("video");

      if (catParam) {
        const cats = window.PANGEA_ATLAS_CATEGORIES || [];
        const match = cats.find(function (c) {
          return c.id.toLowerCase() === catParam.toLowerCase();
        });
        if (match) state.category = match.id;
      }
      if (levelParam) {
        state.level = levelParam;
      }
      if (playlistParam) {
        state.playlistId = playlistParam;
      }
      if (videoParam) {
        setTimeout(function () {
          openVideo(videoParam);
        }, 120);
      }
    } catch (e) {}
  }

  /* --------------------------------------------------------------------------
     9. PUBLIC API & EVENT HANDLERS
     -------------------------------------------------------------------------- */
  function setCategory(catId) {
    state.category = catId;
    state.playlistId = null;
    renderPlaylists();
    renderCategoryTabs();
    renderCatalogGrid();
  }

  function setLevel(levelId) {
    state.level = levelId;
    document.querySelectorAll("[data-pa-level]").forEach(function (el) {
      el.classList.toggle("pa-is-active", el.getAttribute("data-pa-level") === levelId);
    });
    renderCatalogGrid();
  }

  function setFormat(formatId) {
    state.format = formatId;
    document.querySelectorAll("[data-pa-format]").forEach(function (el) {
      el.classList.toggle("pa-is-active", el.getAttribute("data-pa-format") === formatId);
    });
    renderCatalogGrid();
  }

  function toggleQuickFilter(mode) {
    state.quickFilter = (state.quickFilter === mode) ? "alle" : mode;
    updateProgressHeader();
    renderCatalogGrid();
  }

  function selectPlaylist(playlistId) {
    state.playlistId = (state.playlistId === playlistId) ? null : playlistId;
    renderPlaylists();
    renderCategoryTabs();
    renderCatalogGrid();
    const ctrlBar = document.getElementById("paControlBar");
    if (ctrlBar && state.playlistId) {
      ctrlBar.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function onSearchInput(val) {
    state.searchQuery = val || "";
    renderCatalogGrid();
  }

  function clearSearch() {
    state.searchQuery = "";
    const inp = document.getElementById("paSearchInput");
    if (inp) inp.value = "";
    renderCatalogGrid();
  }

  function resetFilters() {
    state.category = "alle";
    state.level = "alle";
    state.format = "alle";
    state.quickFilter = "alle";
    state.playlistId = null;
    state.searchQuery = "";
    const inp = document.getElementById("paSearchInput");
    if (inp) inp.value = "";
    document.querySelectorAll("[data-pa-level]").forEach(function (el) {
      el.classList.toggle("pa-is-active", el.getAttribute("data-pa-level") === "alle");
    });
    document.querySelectorAll("[data-pa-format]").forEach(function (el) {
      el.classList.toggle("pa-is-active", el.getAttribute("data-pa-format") === "alle");
    });
    updateProgressHeader();
    renderPlaylists();
    renderCategoryTabs();
    renderCatalogGrid();
  }

  function toggleSimulatorPlay() {
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const video = videos.find(function (v) { return v.id === state.activeVideoId; });
    if (!video) return;

    if (state.simSeconds >= 120) {
      state.simSeconds = 0;
      state.simPlaying = true;
    } else {
      state.simPlaying = !state.simPlaying;
    }
    const playBtn = document.getElementById("paSimPlayBtn");
    if (playBtn) {
      playBtn.textContent = state.simPlaying ? "⏸ Pause" : "▶ Weiter";
    }
    updateSimulatorUI(video);
  }

  function cycleSimulatorSpeed() {
    const speeds = [1, 1.5, 2];
    const nextIdx = (speeds.indexOf(state.simSpeed) + 1) % speeds.length;
    state.simSpeed = speeds[nextIdx];
    const btn = document.getElementById("paSimSpeedBtn");
    if (btn) btn.textContent = "Tempo: " + state.simSpeed + "x";
  }

  function scrubSimulator(evt) {
    const bar = document.getElementById("paSimTimeline");
    const videos = window.PANGEA_ATLAS_VIDEOS || [];
    const video = videos.find(function (v) { return v.id === state.activeVideoId; });
    if (!bar || !video) return;
    const rect = bar.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (evt.clientX - rect.left) / rect.width));
    state.simSeconds = Math.round(ratio * 120);
    state.simPlaying = true;
    const playBtn = document.getElementById("paSimPlayBtn");
    if (playBtn) playBtn.textContent = "⏸ Pause";
    updateSimulatorUI(video);
  }

  /* --------------------------------------------------------------------------
     10. HELPERS & INITIALISIERUNG
     -------------------------------------------------------------------------- */
  function formatTime(sec) {
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, "&#39;");
  }

  function initPangeaAtlas() {
    loadUserState();
    ensureBodyPortals();
    applyUrlParams();
    updateProgressHeader();
    renderHeroStage();
    renderPlaylists();
    renderCategoryTabs();
    renderCatalogGrid();
    injectVideoSchemaJsonLd();

    // ESC schließt das Kino-Modal
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && state.activeVideoId) {
        closeModal();
      }
    });
  }

  window.PangeaAtlas = {
    init: initPangeaAtlas,
    openVideo: openVideo,
    closeModal: closeModal,
    setCategory: setCategory,
    setLevel: setLevel,
    setFormat: setFormat,
    toggleQuickFilter: toggleQuickFilter,
    selectPlaylist: selectPlaylist,
    onSearchInput: onSearchInput,
    clearSearch: clearSearch,
    resetFilters: resetFilters,
    toggleWatched: toggleWatched,
    toggleBookmark: toggleBookmark,
    jumpToChapter: jumpToChapter,
    toggleSimulatorPlay: toggleSimulatorPlay,
    cycleSimulatorSpeed: cycleSimulatorSpeed,
    scrubSimulator: scrubSimulator
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPangeaAtlas);
  } else {
    initPangeaAtlas();
  }
})();
